import React, { useState, useEffect } from 'react';
import whatsapplogo from "../Images/whatsapplogo.png";
import { BiPhoneCall } from "react-icons/bi";
import { FaChevronUp } from "react-icons/fa";

function Scrollfunctions() {
  const [showScrollTop, setShowScrollTop] = useState(false);
  const [showContactButtons, setShowContactButtons] = useState(false);
  const [lastScrollTop, setLastScrollTop] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      // Show scroll-to-top button when scrolled down > 250px
      if (scrollTop > 250) {
        setShowScrollTop(true);
      } else {
        setShowScrollTop(false);
      }

      // Contact button visibility
      if (scrollTop > lastScrollTop && scrollTop > 150) {
        setShowContactButtons(true);
      } else if (scrollTop <= 150) {
        setShowContactButtons(false);
      }
      setLastScrollTop(scrollTop);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [lastScrollTop]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const handleRedirect = () => {
    window.location.href = "tel:+919016663115";
  };

  const handleRedirectwp = () => {
    window.location.href = "https://wa.me/919016663115?text=Hello%2C%20VIZAURA";
  };

  return (
    <>
      {/* Left Side Scroll To Top Button */}
      <button
        onClick={scrollToTop}
        aria-label="Scroll to top"
        title="Scroll to top"
        className={`fixed bottom-8 left-5 sm:bottom-10 sm:left-8 z-50 p-3 sm:p-3.5 rounded-full bg-[#1E2837] text-white shadow-2xl border border-white/20 transition-all duration-300 hover:bg-yellow-600 hover:scale-110 active:scale-95 flex items-center justify-center group ${
          showScrollTop
            ? 'opacity-100 translate-y-0 pointer-events-auto'
            : 'opacity-0 translate-y-6 pointer-events-none'
        }`}
      >
        <FaChevronUp className="w-4 h-4 sm:w-5 sm:h-5 transition-transform duration-300 group-hover:-translate-y-0.5" />
      </button>

      {/* Right Side Contact Icons */}
      {showContactButtons && (
        <div className="fixed bottom-8 right-5 sm:bottom-10 sm:right-10 transition-all duration-300 flex items-center justify-center gap-2 z-50">
          <div
            className="bg-white rounded-3xl p-1.5 shadow-lg hover:scale-110 transition-transform cursor-pointer"
            onClick={handleRedirect}
            title="Call Us"
          >
            <BiPhoneCall size={28} color="brown" />
          </div>
          <img
            src={whatsapplogo}
            alt="WhatsApp"
            className="h-14 w-14 sm:h-16 sm:w-16 rounded-3xl hover:scale-110 transition-transform cursor-pointer shadow-lg"
            onClick={handleRedirectwp}
            title="Chat on WhatsApp"
          />
        </div>
      )}
    </>
  );
}

export default Scrollfunctions;